<template>
  <div class="changePwd">
    <NavBar :narBarTitle="$t('修改密码')" />
    <van-form @submit="onChangePwd">
      <van-field
        v-model="oldPwd"
        :label="$t('请输入旧密码')"
        :placeholder="$t('请输入')"
        input-align="right"
        class="card"
        name="oldPassword"
        type="password"
        autocomplete="“off”"
        :rules="[
          {
            required: true,
            message: $t('不符合，请输入5位及以上的密码'),
            validator: oldPwdTest,
          },
        ]"
      />
      <div class="newPwdBox">
        <van-field
          v-model="password"
          :label="$t('请输入新密码')"
          :placeholder="$t('请输入')"
          input-align="right"
          name="password"
          class="card"
          type="password"
          autocomplete="“off”"
          :rules="[
            {
              required: true,
              message: $t('不符合，密码格式有误'),
              validator: pwdTest,
            },
          ]"
        />
        <van-field
          v-model="checkPassword"
          :label="$t('请再次输入新密码')"
          :placeholder="$t('请输入')"
          input-align="right"
          name="checkPwd"
          class="card"
          type="password"
          autocomplete="“off”"
          :rules="[
            {
              required: true,
              message: $t('两次密码不一致'),
              validator: checkTest,
            },
          ]"
        />
      </div>
      <div class="passwordNotice">
        <span><img src="@/assets/images/notice.png" alt="" /></span>
        <p>
          {{
            $t(
              '密码修改要求必须包含数字、⼤写字母、⼩写字母、特殊字符4种中⾄少3种，且不少于8位'
            )
          }}
        </p>
      </div>
      <van-button
        round
        block
        type="info"
        native-type="submit"
        :disabled="!changePwdTest"
        class="change-btn"
        :style="{ background: changePwdTest ? '#009BFF' : '#DDDDDD' }"
        >{{ $t('确认修改') }}</van-button
      >
    </van-form>
  </div>
</template>
<script>
import { changePwd } from '@/services/api'
import NavBar from '@/components/navBar'
import { verifyPassword } from '@/utils/utils'
import Vue from 'vue'
import { Form, Field, Button, Toast } from 'vant'
Vue.use(Form)
Vue.use(Field)
Vue.use(Button)
Vue.use(Toast)

export default {
  name: 'changePwd',
  components: {
    NavBar,
  },
  data() {
    return {
      oldPwd: '',
      password: '',
      checkPassword: '',
      staffId: '',
    }
  },
  methods: {
    oldPwdTest() {
      return this.oldPwd.length > 5
    },
    pwdTest() {
      return verifyPassword(this.password)
    },
    checkTest() {
      return this.password === this.checkPassword
    },
    async onChangePwd(v) {
      try {
        await changePwd({
          staffId: this.staffId,
          ...v,
        })
        const state = localStorage.getItem('state')
        if (state && state !== '') {
          Toast.success(this.$t('密码修改成功'))
          this.$router.push('/')
        } else {
          Toast.success(this.$t('密码修改成功'))
          localStorage.removeItem('user')
          let companyCode = { code: JSON.parse(localStorage.getItem('cCode')).code }
          localStorage.setItem('companyCode', JSON.stringify(companyCode))
          localStorage.removeItem('cCode')
          this.$router.push('/login')
        }
      } catch (error) {
        Toast.fail(error.response.data.message)
      }
    },
  },
  computed: {
    changePwdTest() {
      return (
        this.pwdTest() === true &&
        this.checkTest() === true &&
        this.oldPwdTest() === true
      )
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.staffId = this.user.id
  },
}
</script>
<style lang="less" scoped>
.changePwd {
  height: 100%;
  background: #f6f6f6;
  .card {
    height: 56px;
    font-size: 16px;
    display: flex;
    align-items: center;
  }
  /deep/.newPwdBox {
    margin-top: 11px;
    .van-field__error-message {
      text-align: right;
    }
  }
  .change-btn {
    border: none;
    margin: 116px auto 0px;
    width: 351px;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }

  .passwordNotice {
    margin-top: 10px;
    display: flex;
    padding: 0 20px;
    p {
      font-size: 13px;
      color: #00000061;
    }
    img {
      width: 22px;
      height: 22px;
      margin-top: -2px;
    }
  }
}
</style>
